<template>
 <footer class="myworks__footer">
  Visit my <a href="https://parasat00.github.io/">portfolio</a> to learn more
 </footer>
</template>

<script>
 export default {
  
 }
</script>

<style>
.myworks__footer {
 color: #f3f3f3;
 text-align: center;
 padding: 0 0 10px;
}
.myworks__footer a {
 text-decoration: none;
 color: #cea25f;
}
</style>